<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "div",
        { staticClass: "buy" },
        [
          _c(
            "div",
            { staticClass: "pl-2--row" },
            [
              _c(
                "b-row",
                [
                  _c("TabsButton", {
                    attrs: {
                      handleTabChange: _vm.handleTabChange,
                      tabText1: _vm.$t("buy.Buy"),
                      tabText2: _vm.$t("buy.Sell"),
                      selectedTab:
                        _vm.orderType == "BUY"
                          ? 1
                          : _vm.orderType == "SELL"
                          ? 2
                          : 1,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [_c("P2PFilters", { attrs: { callApi: _vm.callApi } })],
                1
              ),
            ],
            1
          ),
          _vm.isDesktopVisible
            ? _c("b-table", {
                staticClass: "mt-2",
                attrs: { items: _vm.items, fields: _vm.fields, responsive: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "cell(userName)",
                      fn: function (data) {
                        return [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "first-text detail-text" },
                              [
                                _c("b-avatar", {
                                  staticClass: "badge-minimal",
                                  attrs: {
                                    size: "40",
                                    variant: "light-primary mr-1",
                                    badge: "",
                                    text: data.value[0] || data.item.email[0],
                                    "badge-variant": "success",
                                  },
                                }),
                                _c(
                                  "div",
                                  { staticClass: "user-name-detail" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          data.value ||
                                            _vm.getUserEmail(data.item.email)
                                        ) +
                                        " "
                                    ),
                                    _c("GoldUser", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: data.item.userLevel === "GOLD",
                                          expression:
                                            "data.item.userLevel === 'GOLD'",
                                        },
                                      ],
                                      staticClass: "user-level",
                                    }),
                                    _c("Silver", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            data.item.userLevel === "REGULAR",
                                          expression:
                                            "data.item.userLevel === 'REGULAR'",
                                        },
                                      ],
                                      staticClass: "user-level",
                                    }),
                                    _c("Platinum", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            data.item.userLevel === "PLATINUM",
                                          expression:
                                            "data.item.userLevel === 'PLATINUM'",
                                        },
                                      ],
                                      staticClass: "user-level",
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "user-name-detail d-flex order-detail-block",
                              },
                              [
                                _c("div", { staticClass: "ml-1 no-wrap" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.item.totalOrder +
                                          " " +
                                          _vm.$t("buy.Orders")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "ml-1 no-wrap" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        data.item.completionRate +
                                          "% " +
                                          _vm.$t("buy.Completion")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "ml-1 no-wrap" }, [
                                  _c(
                                    "div",
                                    { staticClass: "feedback-state" },
                                    [
                                      _c("OrderReview"),
                                      _vm._v(
                                        " " +
                                          _vm._s(data.item.feedbackRate + "%") +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(rate)",
                      fn: function (data) {
                        return [
                          _c("div", { staticClass: "price n-wrap" }, [
                            _vm._v(
                              " " +
                                _vm._s(data.value + " " + data.item.fiat) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(availableQuantity)",
                      fn: function (data) {
                        return [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", [
                              _vm._v(_vm._s(_vm.$t("buy.Available"))),
                            ]),
                            _c(
                              "div",
                              { staticClass: "available-limit n-wrap" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(data.value + " " + data.item.coin) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", [_vm._v(_vm._s(_vm.$t("buy.Limit")))]),
                            _c(
                              "div",
                              { staticClass: "available-limit n-wrap" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      data.item.minOrderPriceLimit +
                                        " " +
                                        data.item.fiat +
                                        " - " +
                                        data.item.maxOrderPriceLimit +
                                        " " +
                                        data.item.fiat
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cell(paymentMethods)",
                      fn: function (data) {
                        return [
                          _c(
                            "div",
                            { staticClass: "payment-method" },
                            [
                              _vm._l(
                                data.value.slice(0, 2),
                                function (method, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "n-wrap" },
                                    [_vm._v(" " + _vm._s(method) + " ")]
                                  )
                                }
                              ),
                              data.value.length > 2
                                ? _c(
                                    "div",
                                    [
                                      _c("feather-icon", {
                                        attrs: {
                                          id: "disabled-wrapper",
                                          icon: "ChevronDownIcon",
                                        },
                                      }),
                                      _c(
                                        "b-tooltip",
                                        {
                                          attrs: {
                                            target: "disabled-wrapper",
                                            placement: "bottom",
                                          },
                                        },
                                        _vm._l(
                                          data.value.slice(2),
                                          function (method, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "n-wrap",
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(method) + " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      },
                    },
                    {
                      key: "cell(operation)",
                      fn: function (data) {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "n-wrap",
                              attrs: { variant: _vm.buttonVariant },
                              on: {
                                click: function ($event) {
                                  return _vm.getOrderDetails(data.item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.buttonLabel) + " ")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2832806560
                ),
              })
            : _c(
                "div",
                { staticClass: "buy-sell-mobile" },
                _vm._l(_vm.items, function (item, index) {
                  return _c("div", { key: index, staticClass: "print-row" }, [
                    _c("div", { staticClass: "print-buy cl-1" }, [
                      _c(
                        "div",
                        { staticClass: "first-text detail-text" },
                        [
                          _c("b-avatar", {
                            staticClass: "badge-minimal",
                            attrs: {
                              size: "40",
                              variant: "light-primary mr-1",
                              badge: "",
                              text:
                                item.userName && item.userName.length
                                  ? item.userName[0]
                                  : item.email[0],
                              "badge-variant": "success",
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "user-name-detail" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.userName ||
                                      _vm.getUserEmail(item.email)
                                  ) +
                                  " "
                              ),
                              _c("GoldUser", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.userLevel === "GOLD",
                                    expression: "item.userLevel === 'GOLD'",
                                  },
                                ],
                                staticClass: "user-level",
                              }),
                              _c("Silver", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.userLevel === "REGULAR",
                                    expression: "item.userLevel === 'REGULAR'",
                                  },
                                ],
                                staticClass: "user-level",
                              }),
                              _c("Platinum", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.userLevel === "PLATINUM",
                                    expression: "item.userLevel === 'PLATINUM'",
                                  },
                                ],
                                staticClass: "user-level",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "user-name-detail d-flex order-detail-block",
                        },
                        [
                          _c("div", { staticClass: "ml-1 no-wrap" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.totalOrder + " " + _vm.$t("buy.Orders")
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "ml-1 no-wrap" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.completionRate +
                                    "% " +
                                    _vm.$t("buy.Completion")
                                ) +
                                " "
                            ),
                          ]),
                          _c("div", { staticClass: "ml-1 no-wrap" }, [
                            _c(
                              "div",
                              { staticClass: "feedback-state" },
                              [
                                _c("OrderReview"),
                                _vm._v(
                                  " " + _vm._s(item.feedbackRate + "%") + " "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "print-buy cl-2" }, [
                      _c("div", { staticClass: "price n-wrap" }, [
                        _vm._v(" " + _vm._s(item.rate + " " + item.fiat) + " "),
                      ]),
                    ]),
                    _c("div", { staticClass: "print-buy cl-3" }, [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", [_vm._v(_vm._s(_vm.$t("buy.Available")))]),
                        _c("div", { staticClass: "available-limit n-wrap" }, [
                          _vm._v(
                            " " +
                              _vm._s(item.availableQuantity + " " + item.coin) +
                              " "
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", [_vm._v(_vm._s(_vm.$t("buy.Limit")))]),
                        _c("div", { staticClass: "available-limit n-wrap" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.minOrderPriceLimit +
                                  " " +
                                  item.fiat +
                                  " - " +
                                  item.maxOrderPriceLimit +
                                  " " +
                                  item.fiat
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "print-buy cl-4" }, [
                      _c(
                        "div",
                        { staticClass: "payment-method" },
                        [
                          _vm._l(
                            item.paymentMethods.slice(0, 2),
                            function (method, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "n-wrap" },
                                [_vm._v(" " + _vm._s(method) + " ")]
                              )
                            }
                          ),
                          item.paymentMethods.length > 2
                            ? _c(
                                "div",
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      id: "disabled-wrapper",
                                      icon: "ChevronDownIcon",
                                    },
                                  }),
                                  _c(
                                    "b-tooltip",
                                    {
                                      attrs: {
                                        target: "disabled-wrapper",
                                        placement: "bottom",
                                      },
                                    },
                                    _vm._l(
                                      item.paymentMethods.slice(2),
                                      function (method, index) {
                                        return _c(
                                          "div",
                                          { key: index, staticClass: "n-wrap" },
                                          [_vm._v(" " + _vm._s(method) + " ")]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "print-buy cl-5" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "n-wrap",
                            attrs: { variant: _vm.buttonVariant },
                            on: {
                              click: function ($event) {
                                return _vm.getOrderDetails(item)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.buttonLabel) + " ")]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-center justify-content-sm-end",
                  attrs: { cols: "12", sm: "12" },
                },
                [
                  _vm.isPaginationVisible
                    ? _c("b-pagination", {
                        key: _vm.page,
                        staticClass: "mb-0 mt-1 mt-sm-0",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.size,
                          "first-number": "",
                          "last-number": "",
                          "prev-class": "prev-item",
                          "next-class": "next-item",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prev-text",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "ChevronLeftIcon",
                                      size: "18",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "next-text",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "ChevronRightIcon",
                                      size: "18",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1308952388
                        ),
                        model: {
                          value: _vm.page,
                          callback: function ($$v) {
                            _vm.page = $$v
                          },
                          expression: "page",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showOrderPop
        ? _c(
            "b-modal",
            {
              attrs: {
                "no-close-on-backdrop": "",
                id: "modal-lg",
                size: "900",
                "modal-class": "modal-w-p",
                "hide-footer": "",
                centered: "",
              },
              model: {
                value: _vm.showOrderPop,
                callback: function ($$v) {
                  _vm.showOrderPop = $$v
                },
                expression: "showOrderPop",
              },
            },
            [
              _vm.orderType === "BUY"
                ? _c("PopupBuy", {
                    attrs: {
                      showHidePop: _vm.showHidePop,
                      feePercent: _vm.feePercent,
                    },
                    model: {
                      value: _vm.orderData,
                      callback: function ($$v) {
                        _vm.orderData = $$v
                      },
                      expression: "orderData",
                    },
                  })
                : _vm._e(),
              _vm.orderType === "SELL"
                ? _c("PopopSell", {
                    attrs: {
                      showHidePop: _vm.showHidePop,
                      feePercent: _vm.feePercent,
                    },
                    model: {
                      value: _vm.orderData,
                      callback: function ($$v) {
                        _vm.orderData = $$v
                      },
                      expression: "orderData",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("KycNotComplete", {
        attrs: {
          showPop: _vm.warningPop,
          onModalHidden: _vm.onModalHidden,
          msg: _vm.warningMsg,
          showButton: _vm.showButton,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/p2p-buy/Buy.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import core_components_tabs_Tabs_vue from '@core/components/tabs/Tabs.vue';
import layouts_components_buy_sell_P2PFilters_vue from '@/layouts/components/buy-sell/P2PFilters.vue';
import layouts_components_buy_sell_GreenPopupBuy_vue from '@/layouts/components/buy-sell/GreenPopupBuy.vue';
import layouts_components_buy_sell_PopupSell_vue from '@/layouts/components/buy-sell/PopupSell.vue';
import libs_api_api from '@/libs/api/api';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import * as vuex from 'vuex';
import layouts_components_KycNotComplete_vue from '@/layouts/components/KycNotComplete.vue';
import assets_rashi_coin_gold_user_svg from '@/assets/rashi-coin/gold-user.svg';
import assets_rashi_coin_silver_svg from '@/assets/rashi-coin/silver.svg';
import assets_rashi_coin_platinum_svg from '@/assets/rashi-coin/platinum.svg';
import assets_rashi_coin_order_review_svg from '@/assets/rashi-coin/order-review.svg';
import utils_constants from '@/utils/constants';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















export default ({
  render,
  staticRenderFns,
  components: {
    BLink: bootstrapvue["BLink"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BContainer: bootstrapvue["BContainer"],
    BCard: bootstrapvue["BCard"],
    BTable: bootstrapvue["BTable"],
    BButton: bootstrapvue["BButton"],
    BAvatar: bootstrapvue["BAvatar"],
    vSelect: vue_select,
    TabsButton: core_components_tabs_Tabs_vue,
    P2PFilters: layouts_components_buy_sell_P2PFilters_vue,
    PopupBuy: layouts_components_buy_sell_GreenPopupBuy_vue,
    BPagination: bootstrapvue["BPagination"],
    BTooltip: bootstrapvue["BTooltip"],
    PopopSell: layouts_components_buy_sell_PopupSell_vue,
    KycNotComplete: layouts_components_KycNotComplete_vue,
    GoldUser: assets_rashi_coin_gold_user_svg,
    Platinum: assets_rashi_coin_platinum_svg,
    Silver: assets_rashi_coin_silver_svg,
    OrderReview: assets_rashi_coin_order_review_svg
  },
  computed: {
    ...vuex.mapState("user", ["user", "refData"]),
    buttonVariant() {
      return this.orderType === "BUY" ? "primary" : "danger";
    },
    buttonLabel() {
      const action = this.orderType === "BUY" ? this.$t("buy.Buy") : this.$t("buy.Sell");
      return `${action}`;
    }
  },
  data() {
    return {
      fields: [{
        key: "userName",
        label: this.$t("buy.Advertisers")
      }, {
        key: "rate",
        label: this.$t("buy.Price")
      }, {
        key: "availableQuantity",
        label: this.$t("buy.AvailableLimit")
      }, {
        key: "paymentMethods",
        label: this.$t("buy.PaymentMethod")
      }, {
        key: "operation",
        label: this.$t("buy.Operation")
      }],
      searchText: "",
      items: [],
      page: 1,
      size: 10,
      lang: this.$route.params.lang,
      isLoading: false,
      isPaginationVisible: false,
      totalRows: 0,
      orderType: "BUY",
      coin: "",
      debounceTimeout: null,
      showIndex: null,
      orderData: null,
      showOrderPop: false,
      feePercent: 0,
      fees: [],
      warningPop: false,
      warningMsg: this.$t("buy.YouDontHaveSupportedPaymentMethod"),
      isDesktopVisible: false,
      firstTime: true,
      showButton: false
    };
  },
  async mounted() {
    this.coin = (this.refData && this.refData.defaultCoin) || (this.$route && this.$route.query && this.$route.query.coin) || "USDT_TRX";
    let flag = 0;
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.page = this.$route.query.page;
      flag++;
    }
    if (this.$route && this.$route.query && this.$route.query.orderType && this.$route.query.orderType !== this.orderType) {
      this.orderType = this.$route.query.orderType;
      flag++;
    }
    if (!flag) {
      this.callDebounce();
    }
    await this.getAllPaymentMethodNames();
    this.getFees();
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        this.isDesktopVisible = entry.contentRect.width > 991;
      }
    });
    resizeObserver.observe(document.body);
    setTimeout(() => {
      this.firstTime = false;
    }, 5 * 1000);
  },
  watch: {
    orderType(newVal, oldVal) {
      if (newVal && oldVal != newVal) {
        let obj = {
          orderType: newVal
        };
        utils_constants["setQueryParams"].apply(this, [obj]);
        this.callDebounce();
      }
    },
    coin(newVal, oldVal) {
      if (newVal && oldVal !== newVal) this.callDebounce();
    },
    refData(newVal, oldVal) {
      if (newVal && oldVal !== newVal && !this.coin) {
        this.coin = newVal.defaultCoin;
      }
    },
    user(newVal, oldVal) {
      if (newVal && oldVal !== newVal) {
        setTimeout(() => {
          if (this.fees && this.fees.length) {
            const Fee = this.fees.find(fee => fee.level === this.user.userLevel);
            if (Fee) {
              this.feePercent = Fee.takerPercentFee;
            } else {
              this.feePercent = 0;
            }
          } else {
            this.getFees();
          }
        }, 1000);
      }
    },
    page(newVal, oldVal) {
      if (newVal && oldVal != newVal) {
        utils_constants["setPagination"].apply(this, [`${this.page}`]);
        this.getAds();
      }
    }
  },
  methods: {
    showHidePop(flag) {
      this.showOrderPop = flag;
      if (!flag) {
        this.orderData = null;
      }
    },
    getUserEmail(email) {
      if (email && email.length) {
        const [username, domain] = email.split("@");
        const maskedUsername = username.slice(0, 2);
        const maskedPart = "*".repeat(3);
        const maskedEmail = `${maskedUsername}${maskedPart}@${domain}`;
        return maskedEmail;
      } else {
        return "";
      }
    },
    openOrderModal(data) {
      this.orderData = data;
      this.showOrderPop = true;
    },
    callDebounce() {
      const debounceTime = 500;
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        this.getAds();
      }, debounceTime);
    },
    callApi(props) {
      if (props) {
        this.coin = props.coin;
        this.paymentMethod = props.selectedPaymentMethod;
        // this.searchText = props.searchText;
        this.orderPriceLimit = props.orderPriceLimit;
        if (this.page === 1) {
          this.getAds();
        }
        if (!this.firstTime) {
          this.page = 1;
        }
      } else {
        this.getAds();
      }
    },
    handleTabChange(tabNumber) {
      if (tabNumber === 1) {
        this.page = 1;
        this.orderType = "BUY";
      } else if (tabNumber === 2) {
        this.page = 1;
        this.orderType = "SELL";
      }
    },
    onModalHidden(props) {
      this.warningPop = props;
    },
    async getAds() {
      try {
        if (this.coin && this.orderType) {
          this.isLoading = true;
          const res = await new libs_api_api().api({
            method: "GET",
            url: `p2p/ad/search`
          }, {
            orderType: this.orderType,
            coin: this.coin,
            paymentMethod: this.paymentMethod || undefined,
            searchText: this.searchText || undefined,
            orderPriceLimit: this.orderPriceLimit || undefined,
            page: this.page,
            size: this.size
          }, {
            isLoading: true
          });
          if (res && res.ads) {
            this.items = res.ads;
            this.totalRows = res.count;
            if (res.count && res.count > this.size) {
              this.isPaginationVisible = true;
            } else {
              this.isPaginationVisible = false;
            }
          } else if (res && res.error && res.error.message) {
            this.items = [];
            this.$toast({
              component: core_components_toastification_ToastificationContent_vue,
              props: {
                title: res.error.message,
                icon: "EditIcon",
                variant: "danger"
              }
            });
          }
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async checkValidUser() {
      if (!this.user || !this.user.verificationStatus || this.user.verificationStatus !== "APPROVED") {
        this.onModalHidden(true);
        this.warningMsg = this.$t("Kyc.kycNotCompleteOrder");
        this.showButton = true;
        return false;
      }
      return true;
    },
    async getOrderDetails(data) {
      try {
        let paymentMethods = [];
        const verificationStatus = await this.checkValidUser();
        if (!verificationStatus) {
          return;
        }
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/ad/detail/${data.id}`
        }, {}, {
          isLoading: true
        });
        const adDetail = (res && res.ad) ? res.ad : res;
        if (adDetail && (adDetail.sellerPaymentMethods || adDetail.paymentMethods || adDetail.id)) {
          if (adDetail.sellerPaymentMethods && adDetail.sellerPaymentMethods.length) {
            paymentMethods = adDetail.sellerPaymentMethods;
          } else if (adDetail.paymentMethods && adDetail.paymentMethods.length) {
            paymentMethods = adDetail.paymentMethods.map((pm, idx) => {
              if (typeof pm === "object" && pm !== null) {
                return pm;
              }
              const pmId = (adDetail.paymentMethodIds && adDetail.paymentMethodIds[idx]) || pm;
              return {
                id: pmId,
                name: pm,
                paymentMethod: pm,
                accountId: pm,
                config: {}
              };
            });
          }
          this.openOrderModal({
            ...data,
            ...adDetail,
            paymentMethodsArray: data.paymentMethods,
            paymentMethods
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res && res.error && res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: (error && error.message) || String(error),
            icon: "EditIcon",
            variant: "danger"
          }
        });
      } finally {
        this.isLoading = false;
      }
    },
    async getAllPaymentMethodNames() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/payment/names`
        }, {
          page: 1,
          size: 100
        }, {
          isLoading: true
        });
        if (res && res.names) {
          this.paymentMethodsOptions = res.names;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async getFees() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `p2p/fees`
        }, {
          page: 1,
          size: 100
        }, {
          isLoading: true
        });
        if (res && res.fees) {
          const Fee = res.fees.find(fee => fee.level === this.user.userLevel);
          this.fees = res.fees;
          if (Fee) {
            this.feePercent = Fee.takerPercentFee;
          } else {
            this.feePercent = 0;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/views/p2p-buy/Buy.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style scoped>
.price {
  color: var(--text-black-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}
.available-limit {
  color: var(--text-black-color);
  font-size: 13.453px;
  font-weight: 500;
  line-height: 22px;
}
[dir=ltr] .available-limit {
  margin-left: 5px;
}
[dir=rtl] .available-limit {
  margin-right: 5px;
}
.first-text {
  color: var(--text-black-color);
  font-size: 13.672px;
  font-weight: 400;
  line-height: 22px;
}
[dir] .advertisers-text {
  margin-top: 5px;
}
[dir=ltr] .user-level {
  margin-left: 5px;
}
[dir=rtl] .user-level {
  margin-right: 5px;
}
.detail-text {
  display: flex;
  align-items: center;
}
.detail-text .user-name-detail {
  display: flex;
  align-items: center;
}
</style>
